import axios from '../axios';

export default {
  getKeys (options) {
    const { pagination = 0, page = 1, limit = 10, filters = {}, include = [] } = options;
    let filtersString = '';

    if (Object.keys(filters).length) {
      for (const filterName in filters) {
        filtersString += `&filter[${filterName}]=${filters[filterName]}`;
      }
    }

    let includeString = '';
    if (include.length) {
      includeString = '&include=' + include.join();
    }

    return new Promise((resolve, reject) => {
      axios.get(`/key?pagination=${pagination}&page=${page}&limit=${limit}${filtersString}${includeString}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getUniversalKeyGroups (options) {
    const { page = 1, limit = 15, filters = {}, include = [] } = options;
    let filtersString = '';

    if (Object.keys(filters).length) {
      for (const filterName in filters) {
        filtersString += `&filter[${filterName}]=${filters[filterName]}`;
      }
    }

    let includeString = '';
    if (include.length) {
      includeString = '&include=' + include.join();
    }

    return new Promise((resolve, reject) => {
      axios.get(`/key/universal-key-groups?page=${page}&limit=${limit}${filtersString}${includeString}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  searchByUniversalCode (options) {
    const {
      code,
      date_from,
      date_to,
      include = [],
    } = options;

    const params = {
      code,
      date_from,
      date_to,
    };

    let includeString = '';
    if (include.length) {
      includeString = '&include=' + include.join();
    }

    return new Promise((resolve, reject) => {
      axios.get(`/key/search/door-journal?${includeString}`, { params })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getKey (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/key/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getKeyDetail (id, options) {
    const params = {};

    if (options.include) {
      params.include = options.include;
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    return new Promise((resolve, reject) => {
      axios.get(`/key/${id}?` + query.join('&'))
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportKeyDoorphonesCsv (id) {
    return new Promise((resolve, reject) => {
      axios.get(`/key/${id}/export-key-doorphones-csv`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  newKey ({ code, name, universal, agent_id, internalReaders, comment, externalReaders }) {
    return new Promise((resolve, reject) => {
      axios.post('/key', {
        code,
        name,
        universal,
        agent_id,
        comment,
        doornum: internalReaders,
        ext_reader_doornum: externalReaders,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  newDoorphoneKey ({ doorphoneId, key }) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/key`, key)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  updateKey ({ id, code, name, universal, internalReaders, comment, externalReaders }) {
    return new Promise((resolve, reject) => {
      axios.put(`/key/${id}`, {
        code,
        name,
        universal,
        doornum: internalReaders,
        comment: comment,
        ext_reader_doornum: externalReaders,
      })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  deleteKey (id) {
    return new Promise((resolve, reject) => {
      axios.delete(`/key/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  exportCsv ({ agentId, doorphoneId }) {
    let paramString = `agent_id=${agentId}`;

    if (doorphoneId) {
      paramString += `&doorphone_id=${doorphoneId}`;
    }

    return new Promise((resolve, reject) => {
      axios.get(`/key/export-csv?${paramString}`, { responseType: 'blob' })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  import (doorphoneId, duplicate) {
    return new Promise((resolve, reject) => {
      axios.post(`doorphone/${doorphoneId}/key/import`, { duplicate })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  export (doorphoneId) {
    return new Promise((resolve, reject) => {
      axios.post(`doorphone/${doorphoneId}/key/export`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  getCardStatus (doorphoneId) {
    return new Promise((resolve, reject) => {
      axios.get(`/doorphone/${doorphoneId}/key/card-status`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  setCardStatus ({ doorphoneId, status }) {
    return new Promise((resolve, reject) => {
      axios.post(`/doorphone/${doorphoneId}/key/card-status`, { status })
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  readKey () {
    return new Promise((resolve, reject) => {
      axios.get('http://127.0.0.1:18989/')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getKeyAuthors () {
    return new Promise((resolve, reject) => {
      axios.get('/key/authors')
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
  getKeyDoorphones (id, options = {}) {
    const { page = 1, limit = 10, include = [] } = options;
    const params = {};

    if (page) {
      params.page = page;
    }

    if (limit) {
      params.per_page = limit;
    }

    if (include.length) {
      params.include = include.join();
    }

    const query = [];
    for (const param in params) {
      query.push(encodeURIComponent(param) + '=' + encodeURIComponent(params[param]));
    }

    const queryString = query.length > 0 ? '?' + query.join('&') : '';

    return new Promise((resolve, reject) => {
      axios.get(`/key/${id}/doorphones${queryString}`)
        .then((response) => {
          resolve(response);
        })
        .catch(error => reject(error));
    });
  },
};
